export enum TaskKey {
    EvaluateMedia = 'EVALUATE_MEDIA',
    SubmitMedia = 'SUBMIT_MEDIA',
    CorrectMedia = 'CORRECT_MEDIA',
    EvaluateSuggestion = 'EvaluateSuggestion', // Deprecated: Remove EvaluateSuggestion in 25.1
    EvaluateThesaurusSuggestion = 'EVALUATE_THESAURUS_SUGGESTION',
    EvaluateUserSuggestion = 'EVALUATE_USER_SUGGESTION'
}

export enum EvaluateMediaPayload {
    RejectedForCorrection = 'RejectedForCorrection',
    Approved = 'Approved'
}

export enum CorrectMediaPayload {
    Submit = 'Submit',
    Delete = 'Delete'
}

export enum EvaluateSuggestionPayload {
    Accepted = 'Accepted',
    Rejected = 'Rejected'
}

export enum TaskActionType {
    Approve = 'Approve',
    RejectForCorrection = 'RejectForCorrection'
}
